import fetch from './fetch'
export function getPageInfo (params) {
  return fetch({
    method: 'get',
    url: 'dev_cms/release/page/info',
    params,
    hideError: true
  })
}
